import environment from "../environment";
import io from "socket.io-client";

const socketModel = io("https://salesmapi.jcsoftwaresolution.in/", {
    transports: ['websocket'], // You can specify transports if needed
});

socketModel.on("connection", () => {
    console.log("Connected to the server");
});

socketModel.on("connect_error", (error) => {
    console.error("Connection error:", error);
});

export default socketModel;
